import { useSelector } from "react-redux";
import styles from "./style.module.scss";

const About = () => {
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  return (
    <div className={styles.aboutContainer}>
      <h2 className={styles.title}>About</h2>
      <p className={styles.content}>{currentUser.bio}</p>
    </div>
  );
};

export default About;
